module.exports = __webpack_public_path__ + "assets/img/LTC002.d82eb84a.png";